import { Pipe, PipeTransform } from '@angular/core'

const AMOUNT_FORMATTER = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
})

@Pipe({
  name: 'formatCurrencyAmount',
  standalone: true
})
export class FormatCurrencyAmountPipe implements PipeTransform {

  public transform(value: number | string, currencyCode = 'USD'): string {
    if (value === null || value === undefined) return ''

    const parsedNumber = typeof value === 'string' ? Number.parseFloat(value) : value

    if (Number.isNaN(parsedNumber)) {
      return `${value} ${currencyCode}`
    }

    const formatted = AMOUNT_FORMATTER.format(parsedNumber)

    return `${formatted} ${currencyCode}`
  }
}
